import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Menu, X, Headphones, LayoutDashboard, User, LogOut } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/episodi", label: "Episodi" },
  { to: "/blog", label: "Blog" },
  { to: "/abbonamenti", label: "Abbonamenti" },
  { to: "/chi-sono", label: "Chi sono" },
  { to: "/contatti", label: "Contatti" },
];

export const Header = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-lg border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="logo-link">
          <span className="w-10 h-10 rounded-xl bg-navy flex items-center justify-center">
            <Headphones className="w-5 h-5 text-gold" />
          </span>
          <div className="leading-tight">
            <span className="block font-serif text-lg font-bold text-navy">Enzo Lavolta</span>
            <span className="block text-[10px] uppercase tracking-[0.25em] text-slate-400">Il Podcast</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={`text-sm font-medium transition-colors ${loc.pathname === l.to ? "text-navy" : "text-slate-500 hover:text-navy"}`}>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin" className="flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-navy">
                  <LayoutDashboard className="w-4 h-4" /> Admin
                </Link>
              )}
              <Link to="/account" data-testid="nav-account" className="flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-navy">
                <User className="w-4 h-4" /> {user.name.split(" ")[0]}
              </Link>
              <button onClick={() => { logout(); nav("/"); }} data-testid="logout-button" className="p-2 text-slate-400 hover:text-navy">
                <LogOut className="w-4 h-4" />
              </button>
            </>
          ) : (
            <>
              <Link to="/accedi" data-testid="login-nav-button" className="text-sm font-medium text-navy hover:text-petrol">Accedi</Link>
              <Link to="/abbonamenti" data-testid="subscribe-nav-button" className="bg-navy text-white hover:bg-petrol rounded-full px-6 py-2.5 text-sm font-medium transition-all shadow-md hover:shadow-lg">
                Abbonati
              </Link>
            </>
          )}
        </div>

        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X className="w-6 h-6 text-navy" /> : <Menu className="w-6 h-6 text-navy" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-100 px-6 py-4 space-y-3">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block py-1.5 text-slate-600 font-medium">{l.label}</Link>
          ))}
          <div className="pt-3 border-t border-slate-100 space-y-2">
            {user ? (
              <>
                {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="block py-1.5 text-navy font-medium">Admin</Link>}
                <Link to="/account" onClick={() => setOpen(false)} className="block py-1.5 text-navy font-medium">Il mio account</Link>
                <button onClick={() => { logout(); setOpen(false); nav("/"); }} className="block py-1.5 text-navy font-medium">Esci</button>
              </>
            ) : (
              <>
                <Link to="/accedi" onClick={() => setOpen(false)} className="block py-1.5 text-navy font-medium">Accedi</Link>
                <Link to="/abbonamenti" onClick={() => setOpen(false)} className="block py-1.5 text-gold font-medium">Abbonati</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
